<main class="nps-publico">
  <header class="cabecalho">
    <span class="marca">PromoKit<span aria-hidden="true">.</span></span>
    <span class="tipo-pesquisa">Pesquisa de experiência</span>
  </header>

  <section class="nps-cartao" [attr.aria-busy]="carregando || enviando">
    <div aria-live="polite" aria-atomic="true">
      <div *ngIf="carregando" class="estado">
        <span class="indicador-carregamento" aria-hidden="true"></span>
        <h1>Preparando sua pesquisa</h1>
        <p>Só um instante enquanto carregamos a avaliação.</p>
      </div>

      <div *ngIf="!carregando && !avaliacao && msgErro" class="estado">
        <span class="icone-estado" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12 8v5m0 3h.01M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></svg>
        </span>
        <h1>Não conseguimos abrir a pesquisa</h1>
        <p>{{msgErro}}</p>
        <button type="button" class="enviar tentar-novamente" (click)="carregueAvaliacao()">Tentar novamente</button>
      </div>

      <ng-container *ngIf="!carregando && avaliacao">
        <div *ngIf="enviado" class="estado agradecimento">
          <span class="icone-estado" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="m6 12 4 4 8-8"/></svg>
          </span>
          <span class="sobretitulo">Resposta recebida</span>
          <h1>Obrigado pela sua opinião!</h1>
          <p>Sua resposta ajuda nossa equipe a melhorar sua experiência com o PromoKit.</p>
          <span class="estado-rodape">Você já pode fechar esta página.</span>
        </div>

        <div *ngIf="!enviado && avaliacao.estado === 'INDISPONIVEL'" class="estado">
          <span class="icone-estado" aria-hidden="true">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
          </span>
          <h1>Pesquisa indisponível</h1>
          <p>O prazo desta avaliação terminou ou o link foi cancelado.</p>
          <span class="estado-rodape">Se precisar, fale com a nossa equipe de suporte.</span>
        </div>
      </ng-container>
    </div>

    <div *ngIf="!carregando && avaliacao && !enviado && avaliacao.estado === 'DISPONIVEL'" class="formulario">
      <span class="empresa">{{avaliacao.empresaNome}}</span>
      <h1 id="perguntaNps">{{avaliacao.pergunta}}</h1>
      <p class="introducao" id="contextoNps">Pense na sua experiência geral com o sistema e com a nossa equipe.</p>

      <fieldset class="escala" [disabled]="enviando" aria-labelledby="perguntaNps" aria-describedby="contextoNps escalaDescricao selecaoNps">
        <legend class="somente-leitor">Selecione uma nota de zero a dez</legend>
        <div class="notas">
          <label class="opcao-nota" *ngFor="let nota of notas">
            <input type="radio" name="notaNps" [value]="nota" [checked]="resposta.nota === nota"
                   [attr.aria-label]="'Nota ' + nota + ' de 10'" (change)="selecioneNota(nota)">
            <span>{{nota}}</span>
          </label>
        </div>
        <div class="extremos" id="escalaDescricao"><span>0 · Nada provável</span><span>10 · Muito provável</span></div>
      </fieldset>

      <p class="selecao" id="selecaoNps" [class.com-nota]="resposta.nota !== null" aria-live="polite" aria-atomic="true">
        <ng-container *ngIf="resposta.nota === null">Selecione uma nota para continuar.</ng-container>
        <ng-container *ngIf="resposta.nota !== null">Nota selecionada: <strong>{{resposta.nota}}</strong> de 10</ng-container>
      </p>

      <div class="comentario" id="blocoComentario">
        <label for="comentarioNps">{{perguntaComentario}} <span class="opcional">Opcional</span></label>
        <p id="comentarioAjuda">{{ajudaComentario}}</p>
        <textarea id="comentarioNps" maxlength="1000" rows="4" [(ngModel)]="resposta.comentario"
                  [disabled]="enviando" aria-describedby="comentarioAjuda comentarioLimite" placeholder="Escreva aqui, se quiser"></textarea>
        <span class="contador" id="comentarioLimite" [class.perto-limite]="resposta.comentario.length > 900">{{resposta.comentario.length}} / 1.000 caracteres</span>
      </div>

      <div class="erro" role="alert" *ngIf="msgErro">{{msgErro}}</div>
      <button type="button" class="enviar" [disabled]="enviando || resposta.nota === null" (click)="enviarAvaliacao()">
        <span *ngIf="enviando" class="indicador-carregamento pequeno" aria-hidden="true"></span>
        {{enviando ? 'Enviando avaliação...' : 'Enviar avaliação'}}
        <svg *ngIf="!enviando" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14m-5-5 5 5-5 5"/></svg>
      </button>
    </div>
  </section>

  <footer class="rodape">A sua experiência nos ajuda a evoluir.</footer>
</main>
